var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 4.05 4.05 0 9 0C13.95 0 18 4.05 18 9C18 13.95 13.95 18 9 18C4.05 18 0 13.95 0 9ZM1.125 9C1.125 13.275 4.6125 16.875 9 16.875C13.3875 16.875 16.875 13.275 16.875 9C16.875 4.725 13.275 1.125 9 1.125C4.725 1.125 1.125 4.725 1.125 9Z",
    fill: "#E64B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 5.17501C12.7125 4.95001 12.375 4.95001 12.15 5.17501L9.22495 8.21251L6.29995 5.17501C6.07495 4.95001 5.73745 4.95001 5.51245 5.17501C5.28745 5.40001 5.28745 5.73751 5.51245 5.96251L8.43745 9.00001L5.39995 12.0375C5.17495 12.2625 5.17495 12.6 5.39995 12.825C5.51245 12.9375 5.62495 12.9375 5.73745 12.9375C5.84995 12.9375 6.07495 12.9375 6.07495 12.825L8.99995 9.78751L11.925 12.825C12.0375 12.9375 12.15 12.9375 12.2625 12.9375C12.375 12.9375 12.4875 12.9375 12.6 12.825C12.825 12.6 12.825 12.2625 12.6 12.0375L10.0125 9.00001L13.05 5.96251C13.1625 5.73751 13.1625 5.40001 12.9375 5.17501Z",
    fill: "#E64B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigCross);
export default __webpack_public_path__ + "static/media/config-cross.a5e2400731b85200f212ccf8836f2144.svg";
export { ForwardRef as ReactComponent };